import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { postAuthSession } from "@/lib/rexxponsApi";
import { useAuth } from "./AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    (async () => {
      if (sessionId) {
        try {
          const u = await postAuthSession(sessionId);
          setUser(u);
          toast.success(`Welcome, ${u.name || u.email}.`);
        } catch {
          toast.error("Sign-in couldn't be completed. Please try again.");
        }
      }
      window.history.replaceState(null, "", window.location.pathname);
      navigate("/", { replace: true });
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background text-foreground">
      <div className="flex items-center gap-3 text-muted-foreground">
        <Loader2 className="w-5 h-5 animate-spin text-primary" /> Signing you in…
      </div>
    </div>
  );
}
